import React from "react";
import {CardDetails, PaymentCardType} from "../../../enums";
import {InputUtils} from "../../../helpers";
import {Chip, Colors, Container, Text} from "../../../ui";
import {PaymentCardTypeIconMap} from "./icons-map";

interface IMethodCard {
  cardDetails: CardDetails;
  hasMorePaymentMethods?: boolean;
  isSelectLabel?: boolean;
  CardMethodMenu: React.FC<{cardDetails: CardDetails}>;
}

export const maskedCardNumber = (last4Digits: number) => {
  return `(****${String(last4Digits)})`;
};

export const MethodCard = ({
  cardDetails,
  hasMorePaymentMethods = false,
  isSelectLabel = false,
  CardMethodMenu,
}: IMethodCard) => {
  const {type, last_4_digits, expired} = cardDetails;
  const icon = PaymentCardTypeIconMap[type];
  const typeLabel = type === PaymentCardType.GENERAL_CARD ? "card" : type;
  return (
    <Container
      fullWidth
      sx={{
        alignItems: "start",
        justifyContent: "center",
        ...(!isSelectLabel && {height: "48px", borderBottom: `1px solid ${Colors.grey._200}`}),
      }}
    >
      <Container fullWidth row sx={{justifyContent: "space-between"}}>
        <Container row sx={{gap: "8px"}}>
          {icon}
          <Text variant={"inter600"} size={14}>
            {InputUtils.prettierSnakeCaseSentence(typeLabel)}
          </Text>
          <Text variant={"inter400"} size={14}>
            {maskedCardNumber(last_4_digits)}
          </Text>
        </Container>
        <Container row sx={{gap: "8px"}}>
          {expired && <Chip label={"Expired"} variant_="error" size="small" />}
          {hasMorePaymentMethods && CardMethodMenu && <CardMethodMenu cardDetails={cardDetails} />}
        </Container>
      </Container>
    </Container>
  );
};
